//
//
//
//
//
//
//
//
//
//
//
//
export default {
  inject: ["main"]
};